var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c("v-col", { attrs: { cols: "12" } }, [
                                _c("h2", [_vm._v("Edit Status")]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "Note: If you are looking to void a corrupted reservation record please use the void feature instead"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "Note: This will only update the status; it will not recalculate the prices, nor dispatch channel manager notifications, nor send emails to hoteliers or clients"
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "3" } }, [
                                _c("label", [_vm._v("Status:")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "9" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.statusOptions,
                                      autocomplete: "",
                                    },
                                    model: {
                                      value: _vm.reservation.status_key,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.reservation,
                                          "status_key",
                                          $$v
                                        )
                                      },
                                      expression: "reservation.status_key",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "3" } }, [
                                _c("label", [_vm._v("Reason For Change:")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "9" } },
                                [
                                  _c("v-text-field", {
                                    attrs: { name: "reason" },
                                    model: {
                                      value: _vm.reason,
                                      callback: function ($$v) {
                                        _vm.reason = $$v
                                      },
                                      expression: "reason",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { title: "Cancel without changes" },
                          on: { click: _vm.cancel },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ies-green",
                          attrs: {
                            title: "Save the changes to the reservation",
                          },
                          on: { click: _vm.saveChanges },
                        },
                        [_vm._v("Save")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }